module.exports = __webpack_public_path__ + "img/hs2.fc97349d.png";